import { render } from "./NotificationsModal.vue?vue&type=template&id=6787320e"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"

import "./NotificationsModal.vue?vue&type=style&index=0&id=6787320e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__